import React, { Suspense } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Header, PortalTour } from '@tecsinapse-org/portal-menu-kit'
import { ManagerProvider, SnackbarProvider } from '@tecsinapse/cortex-react'
import { ConfirmModalProvider } from './core/context/confirm-modal-context'
import { Loading } from './core/components/loading'
import { OpsErrorBoundary } from './core/components/ops-error-boundary'
import { useApp } from './core/hooks/use-app'
import { useTheme } from './core/hooks/use-theme'

export function App() {
  useTheme()
  const { logout, customOptions, currentUser } = useApp()
  const version = import.meta.env.VITE_VERSION
  const { pathname } = useLocation()
  const isFullWidth = pathname.startsWith('/relatorio')

  if (!currentUser) {
    logout?.()
    return null
  }

  return (
    <SnackbarProvider options={{ position: 'bottom-left' }}>
      <ManagerProvider>
        <ConfirmModalProvider>
          <Header
            customOptionsUser={customOptions}
            customBreadcrumbs
            version={version}
            currentProduct={'PORTAL'}
          />
          <OpsErrorBoundary>
            <div
              id='content'
              className={
                isFullWidth
                  ? 'w-screen'
                  : 'max-w-[1440px] w-[calc(100%-32px)] mx-auto overflow-y-scroll'
              }
            >
              <PortalTour steps={[]}>
                <Suspense fallback={<Loading />}>
                  <Outlet />
                </Suspense>
              </PortalTour>
            </div>
          </OpsErrorBoundary>
        </ConfirmModalProvider>
      </ManagerProvider>
    </SnackbarProvider>
  )
}

export default App
